import {useMemo} from "react";

import {MedicalOrganizationTagFormData} from "../components/MedicalOrganizationTags/MedicalOrganizationTags";
import {MedicalOrganizationVaccine} from "../../../types/MedicalOrganizationVaccine";
import {filterMedicalOrganizationVaccines} from "../model/filterMedicalOrganizationVaccines";
import {sortMedicalOrganizationVaccine} from "../model/sortMedicalOrganizationVaccine";
import {usePagination} from "./usePagination";

type UseMedicalOrganizationListViewProps = {
  medicalOrganizationVaccines: MedicalOrganizationVaccine[];
  selectedCategories: string[];
  selectedVaccine: string[];
  tagFormData: MedicalOrganizationTagFormData;
  searchTerm: string;
  sortColumn: string;
  sortOrder: "asc" | "desc";
  currentPage: number;
  pageSize: number;
};

export const useMedicalOrganizationListView = ({
  medicalOrganizationVaccines,
  selectedCategories,
  selectedVaccine,
  tagFormData,
  searchTerm,
  sortColumn,
  sortOrder,
  currentPage,
  pageSize,
}: UseMedicalOrganizationListViewProps) => {
  const filteredMedicalOrganizationVaccines = useMemo(() => {
    return filterMedicalOrganizationVaccines({
      medicalOrganizationVaccines,
      selectedCategories,
      selectedVaccine,
      tagFilters: tagFormData,
      searchTerm
    });
  }, [medicalOrganizationVaccines, selectedCategories, selectedVaccine, searchTerm, tagFormData]);

  const sortedMedicalOrganizationVaccines = useMemo(() => {
    return sortMedicalOrganizationVaccine({
      medicalOrganizationVaccines: filteredMedicalOrganizationVaccines,
      sortColumn,
      sortOrder
    });
  }, [filteredMedicalOrganizationVaccines, sortColumn, sortOrder]);

  const {numberOfPages, paginatedData: paginatedMedicalOrganizationVaccines} = usePagination({
    pageSize,
    data: sortedMedicalOrganizationVaccines,
    currentPage,
  });

  return {
    filteredMedicalOrganizationVaccines,
    sortedMedicalOrganizationVaccines,
    numberOfPages,
    paginatedMedicalOrganizationVaccines,
  };
};
